import React from "react";
import { Typography, Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import dayjs from "dayjs";
import { withTranslation, useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useReduxSelectors";
import { surface, kontram, status, staticText } from "../../../../theme/muiTheme";

const bgColors = { grey: surface.muted, green: kontram.primary, orange: kontram.warning, red: kontram.red };

export const calculateColor = (alarmItem) => {
  // When category is empty or doesn't exist, return
  if (!alarmItem.category) {
    return "grey";
  }
  if (alarmItem.isActive) {
    switch (alarmItem.category) {
      case "Warning":
        return "orange";
      case "SampleCondition":
        return "red";
      case "Device":
        return "red";
      default:
        return "grey";
    }
  } else {
    //When isActive is false
    return "grey";
  }
};

const AlarmItem = ({ alarm, order, onDeleteAlarm }) => {
  const color = calculateColor(alarm);
  const { t } = useTranslation();
  const theme = useTheme();

  const lang = useLanguage();
  return (
    <Box sx={{
      bgcolor: bgColors[color],
      color: "common.white",
      display: "flex",
      pb: "10px",
      boxShadow: `inset -2px 0px 4px -4px ${alpha(theme.palette.common.black, 0.75)}`,
    }}>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignSelf: "center", textAlign: "center", fontSize: "26px", fontWeight: 600 }}>
        {order + 1}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 6 }}>
        <Box sx={{ display: "flex", fontSize: "16px", letterSpacing: "1px" }}>
          <Typography>{alarm.brief}</Typography>
        </Box>
        <Box sx={{ display: "flex", bgcolor: "background.default" }}>
          <Box sx={{ flex: 1, fontSize: "12px", fontWeight: "normal", p: "5px 8px" }}>
            <Typography sx={{ lineHeight: 1, my: "5px" }}>
              {t("Time")}
              <Box component="span" sx={{ display: "block" }}>{dayjs(alarm.sourceTimestamp).format("HH:mm")}</Box>
            </Typography>
            <Typography sx={{ lineHeight: 1, my: "5px" }}>
              {t("Date")}
              <Box component="span" sx={{ display: "block" }}>{dayjs(alarm.sourceTimestamp).format("MM.DD.YY")}</Box>
            </Typography>
            <Typography sx={{ lineHeight: 1, my: "5px" }}>
              {alarm.isActive === true && (
                <Box component="span" sx={{ display: "flex" }}>
                  <Box sx={{ width: 12, height: 12, bgcolor: status.errorDot, mr: "5px", flexShrink: 0, alignSelf: "center" }} />
                  {` ${t("Active")}`}
                </Box>
              )}

              {(alarm.isActive === false) && (
                <Box component="span" sx={{ display: "flex" }}>
                  <Box sx={{ width: 12, height: 12, bgcolor: status.success, mr: "5px", flexShrink: 0, alignSelf: "center" }} />
                  {` ${t("Deactive")}`}
                </Box>
              )}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", flex: 2, bgcolor: "common.white", color: staticText.onWhite, m: 1, lineHeight: 1.1, p: "5px" }}>
            {lang === "en" ? alarm.descriptionEN : alarm.descriptionFI}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};


export default withTranslation("common")(AlarmItem);
